const common = require("lib/labels/_common");

module.exports = {
  invitationList: {
    title: {
      en: "Invitations",
      fr: "Invitations"
    },
    edit: common.edit,
    guests: {
      en: "Guests",
      fr: "Invités"
    },
    expiration: {
      en: "Expiration",
      fr: "Expiration"
    },
    profile: common.profile,
    role: {
      en: "Role",
      fr: "Rôle"
    },
    remove: common.remove
  },
  invitationForm: {
    stepTitle: {
      en: "Invitation",
      fr: "Invitation"
    },
    title: {
      creation: {
        en: "Invitation creation",
        fr: "Création d'invitation"
      },
      edition: {
        en: "Invitation edition",
        fr: "Edition d'invitation"
      }
    },
    name: common.name,
    expiration: {
      label: {
        en: "Token expiration",
        fr: "Expiration du jeton"
      },
      cancel: common.cancel,
      ok: {
        en: "OK",
        fr: "VALIDER"
      }
    },
    comment: {
      en: "Comment",
      fr: "Commentaire"
    },
    role: {
      en: "Role",
      fr: "Rôle"
    },
    profile: common.profile
  },
  guests: {
    title: {
      en: "Guests",
      fr: "Invités"
    },
    pseudo: common.pseudo,
    email: common.email,
    profile: common.profile,
    token: {
      en: "Token",
      fr: "Jeton"
    },
    generate: {
      run: {
        en: "Generate",
        fr: "Générer"
      },
      title: {
        en: "Guest token",
        fr: "Jeton d'invitation"
      },
      close: {
        en: "Close",
        fr: "Fermer"
      }
    },
    save: {
      en: "Save",
      fr: "Enregistrer"
    },
    cancel: common.cancel,
    send: common.send,
    remove: common.remove
  }
};
